import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    {
      /* GNU/Linux Reference documentation */
    }
    <p><img parentName="p" {...{
        "src": "https://icon.now.sh/linux/30/808080",
        "alt": "GNU/Linux"
      }}></img>{` {docs}`}</p>
    {
      /* ![GNU/Linux](../../content/linux-logo.png) */
    }
    {
      /* https://icon.now.sh/linux */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      